import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeRequestDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_17302_13374)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M83.9999 70.5001L85.9999 64.5001",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.0001 68.5L80.5 65.5",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.199 83C46.8656 83.3333 30.699 90.5 19.6991 80.5C15.2441 76.45 25.2941 70.2962 29.5 73C57.5 91 -3.50003 62.5 12 47.5",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round",
				strokeDasharray: "1 3 5 7"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.70704 20.0201C4.26209 18.7824 4.91449 17.9029 6.33961 17.7516L56.7828 12.3947C58.8224 12.1781 61.7581 13.513 63.289 15.3533L75.8895 30.5L89.1651 48.9499C90.2457 50.4517 89.9785 51.7661 88.5152 52.1473L34.9326 66.1058C33.0746 66.5898 30.0325 65.4109 28.4528 63.5129C25.2127 59.6199 19.9519 52.7677 15.5 44.5C10.1304 34.5278 6.23178 24.2614 4.70704 20.0201Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.35381 20.5005C4.55504 19.0252 5.14307 17.8786 6.78802 17.7039L56.7828 12.3947C58.8224 12.1781 61.7581 13.513 63.289 15.3533L72.0399 25.8725C74.5908 28.9388 77.6638 31.9404 81.1486 34.7695L90.945 42.7226C93.2446 44.5895 93.5134 46.7326 91.5099 47.2263L40.643 59.7606C39.2316 60.1083 37.0255 59.4372 35.3516 58.1508C24.6279 49.9098 16.2599 40.6431 11.3455 31.5667L5.35381 20.5005Z",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.88421 20.5603C5.18529 19.2694 5.69982 18.2662 7.13915 18.1133L57.1339 12.804C58.9186 12.6145 61.4873 13.7826 62.8269 15.3928L71.5778 25.912C74.1641 29.0209 77.2798 32.0642 80.813 34.9326L90.6093 42.8857C92.6215 44.5192 92.8567 46.3944 91.1036 46.8264L40.2367 59.3607C39.0172 59.6612 37.1109 59.0812 35.6645 57.9697C25.038 49.8034 16.7458 40.6207 11.8759 31.6265L5.88421 20.5603Z",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .340373,
				y: .0956344,
				width: 19.1873,
				height: .408239,
				transform: "matrix(0.968998 -0.247069 0.698521 0.71559 52.5794 53.271)",
				fill: "#4F49BA",
				stroke: "#4F49BA",
				strokeWidth: .408239
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.4246 43.1037C39.8377 39.4291 40.9636 35.4218 45.9394 34.1531C50.9152 32.8844 57.8566 34.8348 61.4436 38.5093L70.2195 47.4998L52.2005 52.0941L43.4246 43.1037Z",
				stroke: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .680747,
				y: .191269,
				width: .816479,
				height: 4.08239,
				transform: "matrix(0.968998 -0.247069 0.698521 0.71559 56.6634 46.4892)",
				fill: "#4F49BA",
				stroke: "#4F49BA",
				strokeWidth: .816479
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 3.26592,
				cy: 3.26592,
				r: 2.76592,
				transform: "matrix(0.968998 -0.247069 0.698521 0.71559 50.41 42.782)",
				fill: "#4F49BA",
				stroke: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49.0667 44.9487C44.1085 40.3755 41.6525 37.3532 50.5301 35.8194",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M56.0794 32.7991C47.0801 29.4508 37.9026 31.7909 37.7244 37.4792L36.7492 37.29C36.9398 31.2094 46.7502 28.708 56.3701 32.2872L56.0794 32.7991Z",
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M53.2278 29.8778C44.2285 26.5295 35.051 28.8695 34.8727 34.5579L33.8976 34.3687C34.0881 28.2881 43.8986 25.7867 53.5185 29.3659L53.2278 29.8778Z",
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.57065 20.8176C4.30751 19.2279 4.53062 17.7914 6.10078 17.4045L56.7152 4.93246C58.7057 4.44197 62.0017 5.81193 63.6688 7.8227L71.7094 17.5207C74.2919 20.6356 77.4138 23.6846 80.9594 26.5547L90.3836 34.1836C92.6912 36.0516 92.9647 38.2004 90.9579 38.6949L40.3033 51.1768C38.7727 51.554 36.3817 50.829 34.5625 49.4361L30.1302 46.0424C22.5151 40.2117 15.9426 33.8716 10.7884 27.3846L5.57065 20.8176Z",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.04317 20.7909C4.93792 19.3998 5.13315 18.1429 6.50704 17.8044L57.1214 5.33232C58.8631 4.90314 61.7471 6.10185 63.2059 7.86128L71.2464 17.5593C73.8648 20.7174 77.0301 23.8088 80.625 26.7188L90.0491 34.3476C92.0683 35.9821 92.3076 37.8623 90.5516 38.295L39.897 50.777C38.5578 51.107 36.4656 50.4726 34.8738 49.2538L30.4416 45.8601C22.8899 40.078 16.3721 33.7907 11.2609 27.3578L6.04317 20.7909Z",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 25,
				cy: 16,
				r: 1,
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 36,
				cy: 13,
				r: 1,
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 45,
				cy: 11,
				r: 1,
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.2658 34.5842L54.5505 36.9469",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.7021 33.8259L59.1134 34.4829",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.2021 30.6452L20.0641 29.2007C21.6347 28.8137 24.1811 29.7532 25.7517 31.299L32.3139 37.7579C33.8845 39.3038 33.8845 40.8707 32.3139 41.2577L26.4519 42.7021L14.2021 30.6452Z",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M65.5227 20.1581C63.9521 18.6122 63.9521 17.0453 65.5227 16.6583L69.0599 15.7867L81.3097 27.8436L77.7725 28.7152C76.2019 29.1022 73.6555 28.1628 72.0849 26.617L65.5227 20.1581Z",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M64.6383 19.0555L23.207 29.2647L31.9153 37.8358L73.3466 27.6266L64.6383 19.0555ZM49.1394 27.2283L48.7154 29.0073L51.1899 31.0768L51.3354 33.0504L56.0946 31.8776L52.1075 30.5158L50.4494 29.2498L49.1394 27.2283Z",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.557 34.0006L52.7151 38.0689",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.7781 32.8025L62.8284 35.5769",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.4323 40.2968C57.8743 39.8153 57.4896 39.2869 57.344 38.8021L56.1643 34.8746L61.8396 37.6943C62.5402 38.0424 63.1683 38.5108 63.6163 39.0194C64.6012 40.1376 64.5047 41.1921 63.3923 41.4662L62.5429 41.6755C61.4305 41.9496 59.659 41.3554 58.4323 40.2968Z",
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 19.0362,
				height: 1.3397,
				rx: .669851,
				transform: "matrix(0.812515 -0.200215 0.812515 0.79972 30 19.8114)",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.0408 15.3091C23.5 10.8091 23.5 9.99996 20 10.5C17.4761 10.8605 18.5 12.9493 18.5 13.4493",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.7462 12.9391C34.2054 8.43907 34.2054 7.6299 30.7054 8.12991C28.1816 8.49047 28.9999 9.99996 28.9999 10.5",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.7462 10.9391C43.2054 6.43907 43.2054 5.6299 39.7054 6.12991C37.1816 6.49047 38 7.99996 38 8.49997",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55 77L48.5 74",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.5 79.5H48.5",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 26.1273,
				height: 9.79775,
				rx: 4.89887,
				transform: "matrix(0.956901 -0.290416 0.730009 0.683437 54 75.5878)",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.9999 70.5001L85.9999 64.5001",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81 68.5L80.4999 65.5",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M93.9007 98.8938C88.6238 102.814 87.6076 102.877 86.3758 102.58C86.2232 102.543 86.0757 102.486 85.9362 102.409C83.922 101.308 79.8652 98.4159 78.1809 94.7233C77.0855 92.3216 77.051 90.8061 77.3483 89.9339C77.5772 89.2623 78.3895 89.4377 78.8262 90.0321L80.4653 92.2633C81.0541 93.0646 81.4937 92.8047 80.9937 91.9463C79.7287 89.7744 74.1836 82.6887 70.5318 78.116C69.6076 76.9587 68.5025 75.477 68.5449 74.0301C68.5761 72.9671 70.4403 72.6803 71.4228 73.1149C72.5461 73.6118 73.8211 74.3481 74.3966 74.7417C75.2395 75.3183 77.658 76.9725 80.6923 80.6518C80.6959 80.4263 80.7391 80.2015 80.8243 79.9881C80.9959 79.5583 81.3221 79.2166 81.7401 79.0293L82.0402 78.8947C82.7281 78.5863 83.5509 78.7171 84.1537 79.2307L85.9647 80.7736L84.9306 79.2083C84.5277 78.5986 84.5157 77.8219 84.9 77.2418C85.0461 77.0214 85.2406 76.8369 85.4835 76.7335C86.0968 76.4727 87.0765 76.1981 87.8674 76.4339C89.0858 76.7972 92.0322 79.3707 96.6227 85.2427C97.2545 86.0509 100.483 89.7416 100.263 91.4935C100.044 93.2454 99.5002 94.7342 93.9007 98.8938Z",
				fill: "none",
				stroke: "white",
				strokeOpacity: .48,
				strokeWidth: 1,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_17302_13374",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgHomeRequestDark;
